import defaultConfig from './default'
import developmentConfig from './development'
import euConfig from './eu.json'
import productionConfig from './production'
import qaConfig from './qa.json'
import usConfig from './us.json'

declare global {
  interface Window {
    DRIFT_CONFIG: any
    DRIFT_REGION: string
    DRIFT_USSR: boolean
    __ENV__: string
    Bridge: any
    FS: any
    gtag: (...args: any[]) => void
    dataLayer:
      | {
          push: (...args: any[]) => void
        }
      | any[]
    google_optimize: any
  }
}

const localConfigs: any = {
  QA: qaConfig,
  EU: euConfig,
  US: usConfig,
  PRODUCTION: productionConfig,
  DEVELOPMENT: developmentConfig
}

export const isEU = window.DRIFT_REGION === 'EU'

export const config = {
  ...(window.DRIFT_CONFIG || {}),
  ...defaultConfig,
  ...localConfigs[window.DRIFT_REGION || (window.__ENV__ === 'PRODUCTION' ? 'US' : 'QA')],
  ...localConfigs[window.__ENV__ === 'PRODUCTION' ? 'PRODUCTION' : 'DEVELOPMENT']
}

export default config
